<template>
  <div>
    <div class="bg-white p-5">
      <Lynx-Title text="Parcelamento" />

      <label v-if="listaCampos == null" class="flex-col w-full">
        <Lynx-Label label="Empresa" />
        <b-autocomplete
          :data="filteredEmpresas"
          placeholder="Pesquise uma empresa"
          field="empresa"
          :loading="loading"
          @input="getAsyncEmpresa"
          @select="(option) => (form.empresa_id = option.id)"
        />
      </label>

      <Lynx-Input
      v-else
        disabled
        v-model="empresa.razao_social"
        placeholder="Digite a data de vencimento"
      />

      <div class="flex">
        <div class="mt-2">
          <Lynx-Label label="Selecione Tipo parcelamento" />
          <treeselect
            :multiple="false"
            :options="lista_tipo_parcelamento"
            placeholder="Selecione o tipo de parcelamento"
            v-model="form.tipo_parcelamento_id"
          />
        </div>
      </div>

      <div class="mt-2">
        <Lynx-Label label="Observação" />
        <LynxTextarea v-model="form.observacao" />
      </div>

      <div v-if="listaCampos != null">
        <Lynx-Label label="Situação" />

        <Treeselect
          :multiple="false"
          v-model="form.status"
          :options="[
            { id: 1, label: 'Pago' },
            { id: 2, label: 'Normal' },
            { id: 3, label: 'Devedora' },
            { id: 4, label: 'Desistencia' },
            { id: 5, label: 'Não formalizado' },

          ]"
          placeholder="Selecione um status"
        />
      </div>

      <div class="mt-4" v-if="listaCampos == null">
        <Lynx-Label label="Parcelas" />
        <div
          v-for="(parcela, index) in form.parcelas"
          :key="index"
          class="mb-4"
        >
          <div class="flex">
            <div class="mr-2">
              <Lynx-Label label="Valor" />

              <InputMoney
                placeholder="Digite um valor"
                v-model="parcela.valor"
              />
            </div>
            <div class="mr-2">
              <Lynx-Label label="Data de Vencimento" />
              <Lynx-Input
                type="date"
                v-model="parcela.data_vencimento"
                placeholder="Digite a data de vencimento"
              />
            </div>
            <div class="mr-2">
              <Lynx-Label label="Quantidade" />
              <Lynx-Input
                v-model="parcela.quantidade"
                placeholder="Digite a quantidade"
              />
            </div>
          </div>
          <div class="flex items-center">
            <b-button
              @click="removeParcela(index)"
              type="is-danger"
              class="ml-2 mt-4"
              >Remover</b-button
            >
          </div>
        </div>
        <b-button
          @click="addParcela"
          type="is-primary"
          class="mt-2"
          icon-right="plus"
          >Adicionar Parcela</b-button
        >
      </div>

      <b-button
        :disabled="loading"
        @click.native="confirm(listaCampos == null ? 'cria' : 'edita')"
        type="is-primary"
        class="mt-4"
        >{{ listaCampos == null ? "Criar" : "Atualizar" }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { hasRole } from "@/utils/can";
import Treeselect from "@riophae/vue-treeselect";
import LynxTextarea from "@/components/helpers/Textarea";
import InputMoney from "@/components/helpers/InputMoney";
import { searchEmpresasRequest } from "@/services/requests/empresas";
import debounce from "@/mixins/debounce";
export default {
  mixins: [debounce],
  components: { Treeselect, LynxTextarea, InputMoney },
  props: {
    listaCampos: {
      type: Object,
      default: null,
    },
    empresa: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        tipo_parcelamento_id: null,
        observacao: null,
        empresa_id: null,
        parcelas: [
          {
            valor: null,
            data_vencimento: null,
            quantidade: null,
          },
        ],
      },
      empresas: [],
      loading: false,
    };
  },
  created() {
    this.preexerCampos();
  },
  computed: {
    lista_tipo_parcelamento() {
      return this.$store.state.tipoParcelamento.lista_tipo_parcelamento.map(
        (tipo) => ({
          id: tipo.id,
          label: tipo.nome,
        })
      );
    },
    filteredEmpresas() {
      return this.empresas.map((item) => {
        return {
          id: item.id,
          empresa: `${item.id} - ${item.razao_social}`,
        };
      });
    },
    mensagem_alert() {
      return this.$store.state.parcelamento.mensagem_alert;
    },
  },
  methods: {
    hasRole,
    async confirm(tipo) {
      await this.$buefy.dialog.confirm({
        message:
          `Esta ação irá ` +
          tipo +
          ` um parcelamento no sistema. Você deseja continuar?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo === "cria") this.create();
          if (tipo === "edita") this.update();
        },
      });
    },
    async create() {
      this.loading = true;
      await this.$store
        .dispatch("parcelamento/create_parcelamento", this.form)
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
            this.$emit("listarEmpresaParcelamento");
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
        })
        .catch((error) => {
          this.$snack.error(this.mensagem_alert.message);
        })
        .finally(() => (this.loading = false));
    },
    async update() {
      this.loading = true;
      await this.$store
        .dispatch("parcelamento/update_parcelamento", this.form)
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
            this.$emit("listarEmpresaParcelamento");
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
        })
        .catch((error) => {
          this.$snack.error(this.mensagem_alert.message);
        })
        .finally(() => (this.loading = false));
    },

    addParcela() {
      this.form.parcelas.push({
        valor: null,
        data_vencimento: null,
        quantidade: null,
      });
    },
    removeParcela(index) {
      this.form.parcelas.splice(index, 1);
    },
    getAsyncEmpresa(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.loading = true;
        searchEmpresasRequest(name)
          .then((response) => {
            self.empresas = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.loading = false));
      }, 600);
    },

    preexerCampos() {
      if (this.listaCampos != null) {
        this.form = {
          id: this.listaCampos.id,
          observacao: this.listaCampos.observacao,
          tipo_parcelamento_id: this.listaCampos.tipo_parcelamento_id,
          empresa_id: this.listaCampos.empresa_id,
          status: this.listaCampos.status,
          parcelas: [],
        };
      }
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
</style>
